/* Keeps a free Kitty Belt Buckle line in the cart whose quantity always
   matches the KittyMobile quantity, so the gift shows up at checkout and
   on the order. The buckle line itself is hidden in the cart drawer and
   cart page (the drawer shows the gift via the bundle-contents display
   instead), and the cart count bubble excludes it. Config comes from
   window.KittyBeltBuckleSync set in layout/theme.liquid. */
(function () {
  var cfg = window.KittyBeltBuckleSync;
  if (!cfg || !cfg.buckleVariantId) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var syncing = false;
  var pending = false;

  /* Cart line numbers shift when the hidden buckle line is added or
     removed (newest lines sit on top), so the drawer the theme rendered
     just before our mutation carries stale data-index values — its
     remove/quantity controls would target the wrong line. Re-fetch the
     drawer and bubble sections and swap them in after every mutation. */
  function refreshCartUI() {
    return fetch(root + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && sections['cart-drawer']) {
          var fresh = new DOMParser()
            .parseFromString(sections['cart-drawer'], 'text/html')
            .querySelector('cart-drawer');
          if (fresh) {
            drawer.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
            drawer.innerHTML = fresh.innerHTML;
          }
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var freshBubble = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          var inner = freshBubble.querySelector('.shopify-section') || freshBubble.body;
          bubble.innerHTML = inner.innerHTML;
        }
      })
      .catch(function () {});
  }

  function reconcile() {
    if (syncing) {
      pending = true;
      return;
    }
    syncing = true;
    fetch(root + 'cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var kittymobileQty = 0;
        var buckleQty = 0;
        cart.items.forEach(function (item) {
          if (item.handle === cfg.kittymobileHandle) kittymobileQty += item.quantity;
          if (item.variant_id === cfg.buckleVariantId) buckleQty += item.quantity;
        });
        if (buckleQty === kittymobileQty) return null;
        var mutation;
        if (buckleQty === 0) {
          mutation = fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: cfg.buckleVariantId, quantity: kittymobileQty }] })
          });
        } else {
          mutation = fetch(root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: String(cfg.buckleVariantId), quantity: kittymobileQty })
          });
        }
        return mutation.then(refreshCartUI);
      })
      .catch(function () {})
      .then(function () {
        syncing = false;
        if (pending) {
          pending = false;
          reconcile();
        }
      });
  }

  /* Re-check after any cart mutation made by theme code or apps. Our own
     add/change calls above also pass through here; they trigger one extra
     reconcile that finds the quantities equal and stops. */
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var result = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      result.then(
        function () {
          setTimeout(reconcile, 50);
        },
        function () {}
      );
    }
    return result;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcile);
  } else {
    reconcile();
  }
})();
